import React, { Component, Fragment } from 'react';
import { Phone } from './ReactIcons/Phone';

export class TableSimpleRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            message: null,
            isError: false
        };
    }

    render() {
        return (
            <Fragment>
                {this.props.text
                    ? <tr>
                        <td>{this.props.title}</td>
                        <td>

                            {this.props.phone
                                ? <Phone
                                    phone={this.props.text}
                                    text={this.props.text} />
                                : this.props.text}
                        </td>
                    </tr >
                    : null}
            </Fragment>
        );
    }
}